/* gk-patches */
if (!customElements.get('gk-patches')) {
  class GkPatches extends HTMLElement {
    connectedCallback() {
      this.toggles = Array.from(this.querySelectorAll('[data-gkp-toggle]'));
      this.toggles.forEach((input) => {
        input.addEventListener('change', () => {
          // Comportamento radio: se ativou esse, desativa os outros
          if (input.checked) {
            this.toggles.forEach((other) => {
              if (other !== input && other.checked) {
                other.checked = false;
              }
            });
          }
          this.toggles.forEach((t) => this.updateUI(t));
        });
        this.updateUI(input);
      });

      // Badges sempre visiveis em cartoes com imagem (sem lista fechada)
      this.setupTiles();

      this.handleSubmit = this.handleSubmit.bind(this);
      document.addEventListener('submit', this.handleSubmit, true);
    }

    disconnectedCallback() {
      document.removeEventListener('submit', this.handleSubmit, true);
    }

    setupTiles() {
      if (this.classList.contains('gkpa--tiles')) return;
      const list = this.querySelector('.gkpa__list');
      const items = list ? Array.from(list.querySelectorAll('.gkpa__item')) : [];
      if (!items.length) {
        // Sem badges para esta camisola: esconde a caixa inteira
        this.style.display = 'none';
        return;
      }
      this.classList.add('gkpa--tiles');

      const allFree = items.every((i) => {
        const p = i.querySelector('.gkpa__price');
        return !p || !/[1-9]/.test(p.textContent);
      });
      if (!allFree) this.classList.add('gkpa--paid');

      const head = document.createElement('div');
      head.className = 'gkpa__head';
      const title = this.querySelector('.gkpa__title');
      if (title) {
        title.parentNode.insertBefore(head, title);
        head.appendChild(title);
      } else {
        this.insertBefore(head, list);
      }
      if (allFree) {
        const free = document.createElement('span');
        free.className = 'gkpa__free';
        free.textContent = 'GRÁTIS';
        head.appendChild(free);
      }
      const hint = document.createElement('span');
      hint.className = 'gkpa__hint';
      hint.textContent = 'Escolhe 1';
      head.appendChild(hint);

      const checkSvg =
        '<svg viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round"><polyline points="5 12.5 10 17 19 7"/></svg>';

      items.forEach((item) => {
        const nameEl = item.querySelector('.gkpa__name');
        if (nameEl) {
          const full = nameEl.textContent;
          nameEl.textContent = this.shortName(full);
          // Posicao (manga / peito / peito e manga) vem do texto entre parenteses
          const posMatch = full.match(/\(([^)]+)\)/);
          if (posMatch && !item.querySelector('.gkpa__pos')) {
            const pos = document.createElement('span');
            pos.className = 'gkpa__pos';
            pos.textContent = posMatch[1].trim();
            nameEl.insertAdjacentElement('afterend', pos);
          }
        }
        const row = item.querySelector('.gkpa__row');
        if (row && !row.querySelector('.gkpa__check')) {
          const check = document.createElement('span');
          check.className = 'gkpa__check';
          check.setAttribute('aria-hidden', 'true');
          check.innerHTML = checkSvg;
          row.appendChild(check);
        }
      });

      // 1.o cartao: "Nao adicionar badge" (ja escolhido). Nao e um badge real: nada vai para o carrinho.
      const none = document.createElement('li');
      none.className = 'gkpa__item gkpa__item--none';
      none.innerHTML =
        '<button type="button" class="gkpa__row" aria-pressed="true">' +
        '<span class="gkpa__img gkpa__img--none" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><circle cx="12" cy="12" r="9"/><line x1="5.7" y1="18.3" x2="18.3" y2="5.7"/></svg></span>' +
        '<span class="gkpa__text"><span class="gkpa__name">Não adicionar badge</span></span>' +
        '<span class="gkpa__check" aria-hidden="true">' + checkSvg + '</span>' +
        '</button>';
      list.insertBefore(none, list.firstChild);
      this.noneItem = none;
      none.querySelector('button').addEventListener('click', () => {
        this.toggles.forEach((t) => {
          t.checked = false;
          this.updateUI(t);
        });
        this.syncNone();
      });
      this.syncNone();
    }

    // "Nao adicionar badge" fica escolhido sempre que nenhum badge estiver marcado
    syncNone() {
      if (!this.noneItem) return;
      const any = this.toggles.some((t) => t.checked);
      this.noneItem.classList.toggle('is-active', !any);
      const btn = this.noneItem.querySelector('button');
      if (btn) btn.setAttribute('aria-pressed', any ? 'false' : 'true');
    }

    // Nome curto so para o cartao (o nome enviado para o carrinho nao muda)
    shortName(n) {
      const original = (n || '').trim();
      let s = original.replace(/^badge\s+/i, '').replace(/\(.*?\)/g, '').replace(/\s+/g, ' ').trim();
      if (s && s === s.toUpperCase()) {
        s = s.toLowerCase().replace(/(^|\s)\S/g, (m) => m.toUpperCase());
      }
      return s || original;
    }

    setupCollapse() {
      const title = this.querySelector('.gkpa__title');
      const list = this.querySelector('.gkpa__list');
      if (!title || !list || this.querySelector('.gkpa__toggle')) return;
      if (!list.querySelector('.gkpa__item')) return;
      if (!list.id) list.id = 'gkpa-list-' + Math.random().toString(36).slice(2, 8);
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'gkpa__toggle';
      btn.style.color = title.style.color;
      btn.setAttribute('aria-expanded', 'false');
      btn.setAttribute('aria-controls', list.id);
      btn.innerHTML =
        '<span class="gkpa__toggle-text"></span>' +
        '<span class="gkpa__toggle-hint">Opcional</span>' +
        '<svg class="gkpa__chev" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="6 9 12 15 18 9"/></svg>';
      btn.querySelector('.gkpa__toggle-text').textContent = title.textContent.trim();
      title.replaceWith(btn);
      this.classList.add('is-collapsible');
      btn.addEventListener('click', () => this.setOpen(!this.classList.contains('is-open')));
      if (this.toggles.some((t) => t.checked)) this.setOpen(true);
    }

    setOpen(open) {
      this.classList.toggle('is-open', open);
      const btn = this.querySelector('.gkpa__toggle');
      if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    updateUI(input) {
      const item = input.closest('.gkpa__item');
      if (item) item.classList.toggle('is-active', input.checked);
      this.syncNone();
    }

    isCartAddForm(form) {
      if (!(form instanceof HTMLFormElement)) return false;
      const action = form.getAttribute('action') || '';
      return action.indexOf('/cart/add') !== -1;
    }

    getActivePatches() {
      const result = [];
      this.toggles.forEach((input) => {
        if (!input.checked) return;
        const item = input.closest('.gkpa__item');
        if (!item) return;
        const variantId = item.dataset.gkpVariantId;
        const name = item.dataset.gkpName || '';
        if (variantId) result.push({ id: parseInt(variantId, 10), name: name });
      });
      return result;
    }

    handleSubmit(e) {
      const form = e.target;
      if (!this.isCartAddForm(form)) return;

      const productInfo = this.closest('product-info');
      if (productInfo && !productInfo.contains(form)) return;

      // Re-submissão feita por nós mesmos (passo 4): deixa o Dawn seguir com a property "Badges"
      if (this.resubmitting) {
        this.resubmitting = false;
        return;
      }

      const patches = this.getActivePatches();
      if (patches.length === 0) {
        // Nenhum badge marcado: remove a property "Badges" que tenha sobrado de uma adição anterior
        const stale = form.querySelector('input[name="properties[Badges]"]');
        if (stale) stale.remove();
        return;
      }

      e.preventDefault();
      e.stopImmediatePropagation();

      this.submitWithPatches(form, patches);
    }

    async submitWithPatches(form, patches) {
      const submitBtn = form.querySelector('[type="submit"]');
      const productForm = form.closest('product-form');

      // Dawn's cart instance (cart-notification or cart-drawer)
      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

      if (submitBtn) {
        submitBtn.setAttribute('aria-disabled', 'true');
        submitBtn.classList.add('loading');
        const spinner = submitBtn.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');
      }
      if (productForm) {
        productForm.handleErrorMessage && productForm.handleErrorMessage();
      }

      try {
        const cartAddUrl =
          (window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js';

        // 1. Adiciona cada badge via fetch (silencioso, sem renderizar drawer)
        for (const p of patches) {
          const f = new FormData();
          f.append('id', p.id);
          f.append('quantity', 1);
          const r = await fetch(cartAddUrl, {
            method: 'POST',
            headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
            body: f,
          });
          const d = await r.json();
          if (!r.ok || d.status) throw d;
        }

        // 2. Insere property "Badges" no form principal (input hidden)
        const names = patches.map((p) => p.name).filter(Boolean).join(', ');
        if (names) {
          let badgesInput = form.querySelector('input[name="properties[Badges]"]');
          if (!badgesInput) {
            badgesInput = document.createElement('input');
            badgesInput.type = 'hidden';
            badgesInput.name = 'properties[Badges]';
            form.appendChild(badgesInput);
          }
          badgesInput.value = names;
        }

        // 3. Desmarca os toggles pra próxima submissão não disparar nosso intercept
        this.toggles.forEach((t) => {
          t.checked = false;
          this.updateUI(t);
        });

        // 4. Re-submete o form — Dawn vai interceptar e fazer o flow nativo (que funciona)
        if (submitBtn) {
          submitBtn.classList.remove('loading');
          submitBtn.removeAttribute('aria-disabled');
          const spinner = submitBtn.querySelector('.loading__spinner');
          if (spinner) spinner.classList.add('hidden');
        }

        if (form.requestSubmit) {
          this.resubmitting = true;
          form.requestSubmit(submitBtn || undefined);
          this.resubmitting = false; // o evento submit é síncrono; garante que a trava não fique presa
        } else {
          form.submit();
        }
        return; // sai antes do finally pra não desabilitar de novo
      } catch (err) {
        console.error('[gk-patches] add error', err);
        const msg =
          (err && (err.description || err.message)) || 'Não foi possível adicionar ao carrinho.';
        if (productForm && typeof productForm.handleErrorMessage === 'function') {
          productForm.handleErrorMessage(msg);
        } else {
          alert(msg);
        }
      } finally {
        if (submitBtn) {
          submitBtn.classList.remove('loading');
          submitBtn.removeAttribute('aria-disabled');
          const spinner = submitBtn.querySelector('.loading__spinner');
          if (spinner) spinner.classList.add('hidden');
        }
      }
    }
  }
  customElements.define('gk-patches', GkPatches);
}
